module.exports = __webpack_public_path__ + "55453ac8553af404b1ae0e1bc054cb41.jpg";